package at.theatervogelweide.admin.web

import org.jetbrains.compose.web.renderComposable

fun main() {
    val api = AdminApi()
    val router = Router.forWindow()

    renderComposable(rootElementId = "root") {
        App(api, router)
    }
}
